import { useState, useCallback } from 'react';

const useStateRef = processNode => {
  const [node, setNode] = useState(null);
  const setRef = useCallback(newNode => {
    setNode(processNode(newNode));
  }, [processNode]);
  return [node, setRef];
};

export { useStateRef };
//# sourceMappingURL=state-ref.js.map
